module.exports = __webpack_public_path__ + "img/aboutus-img.dc060ae2.jpg";